module.exports = __webpack_public_path__ + "static/media/confident_purchases-desktop.18b257cf.png";